export class BPShiftStatus {
}
BPShiftStatus.preplanned = 1;
BPShiftStatus.planned = 2;
